import $ from 'jquery';

export default function initVideoIframeModule() {
  function closeModalAndStopIframe($modal, $iframe, url) {
    $modal.attr('aria-hidden', 'true');
    if ($iframe.length) {
      $iframe.attr('src', ''); // Stop the video
      $iframe.attr('src', url); // Reset to original URL
    }
  }

  $('.video-module')
    .each(function () {
      const $module = $(this);
      const $thumbnail = $module.find('.video-module__thumbnail');

      // Skip if video opens in a new tab
      if ($thumbnail.closest('a').length) {
        return;
      }

      const modalId = $thumbnail.attr('aria-controls');
      const $modal = $(`#${modalId}`);
      const $iframe = $modal.find('iframe');

      // Check if Complianz or similar is managing the iframe
      let ogUrl = $iframe.attr('src');
      if (ogUrl.toLowerCase() === 'about:blank') {
        ogUrl = $iframe.data('src-cmplz');
      }

      if ($thumbnail.length && $modal.length) {
        // Open modal
        $thumbnail.on('click', () => {
          $iframe.attr('src', `${ogUrl}?autoplay=1`);
          $modal.attr('tabindex', '-1') // Ensure modal is focusable for keyup events
            .attr('aria-hidden', 'false')
            .focus();
        });

        // Close modal on close button click
        const $closeButton = $modal.find('.video-module__modal-close');
        if ($closeButton.length) {
          $closeButton.on('click', () => closeModalAndStopIframe($modal, $iframe, ogUrl));
        }

        // Close modal on overlay click
        $modal.on('click', (e) => {
          if (
            $(e.target)
              .hasClass('video-module__modal') || $(e.target)
              .hasClass('video-module__modal-wrapper')) {
            closeModalAndStopIframe($modal, $iframe, ogUrl);
          }
        });

        // Close modal on Escape key press
        $modal.on('keyup', (e) => {
          if (e.key === 'Escape') {
            closeModalAndStopIframe($modal, $iframe, ogUrl);
          }
        });
      }
    });
}
